import styled from "styled-components";

//color control
const baseMenuColorA = 'rgb(0,20,30)';
const baseMenuColorB = 'rgb(1,80,120)';
//font control
const baseMenuFontColor = 'rgb(122,193,219)';
const baseMenuFontColorHover = 'rgb(54,54,54)';
const baseMenuFontColorActive = 'rgb(0,0,0)';
//button control
const baseMenuButtonColor = 'rgba(0,0,0,0)';
const baseMenuButtonColorHover = 'rgb(122,193,219)';
const baseMenuButtonColorActive = 'rgb(176,253,253)';
//other control
const baseSideMenuButtonColor = 'rgb(200,200,200)';
const baseMenuBorderColor = 'rgb(122,193,219)';
const baseHeaderIconShadow = '1.5px 1.5px 2px 0px #000000';
//animate control
const baseMenuButtonShadowHover = '2.5px 2.5px 5px 0px #000000';
const baseMenuButtonShadowActive = '0px 0px 0px 0px #000000';


/*sidemenu.jsx*/
export const SideTitleDiv = styled.div`
  padding: 20px 0px 20px 0px;
  width: 100%;
  background-color: rgba(0, 132, 255, 0.1);
  vertical-align: middle;
  @media screen and (max-height: 600px) {
    display:none;
  }
`

export const SideImg = styled.img`
  width:40px;
  height:40px;
  margin: -5px 10px 0px 0px;
  border-radius: 50%;
  -webkit-box-shadow: ${baseHeaderIconShadow};
          box-shadow: ${baseHeaderIconShadow};
  @media screen and (max-width: 600px) {
    width:50px;
    height:50px;
  }
  @media screen and (max-height: 600px) {
    width:40px;
    height:40px;
  }
  @media screen and (max-height: 400px) {
    width:30px;
    height:30px;
  }
  @media screen and (max-height: 400px) and (max-width: 400px) {
    display:none;
  }
  z-index: 500;
`

export const SideDiv = styled.div`
  position: fixed;
  top: 0;
  left: ${props => (props.isOpen ? "0px" : "-400px")};
  height: 100%;
  width: 300px;
  background: linear-gradient(to bottom right, ${baseMenuColorA} 50%, ${baseMenuColorB} 100%);
  box-shadow: ${props => props.isOpen ? "2.5px 2.5px 5px 0px #000000;" : "0px 0px 0px 0px #000000;"};
  transition: left 0.4s cubic-bezier(0, 0, 0, 1);
  text-align: center;
  z-index:5000;
  /*CSS animate*/
  -webkit-transition: 0.5s all ease-out;
       -o-transition: 0.5s all ease-out;
          transition: 0.5s all ease-out;
  @media(max-width: 600px) {
    width:${props => (props.isOpen ? "100%" : "-300px")};
    padding: 5px 5px 5px 5px;
  }
`;

export const DivContent = styled.div`
  width: 100%;
  height: 80%;
  color: white;
  padding:20px 20px 20px 20px;
  background-color: rgba(0,0,0,0.3);
  border-radius: 0px;
  border: 2px solid ${baseMenuBorderColor};
  z-index:1000;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  @media(max-width: 600px) {
    height: 70%;
  }
`;

export const SideModal = styled.div`
  position: fixed;
  top: 0;
  height: 100%;
  width: ${props => (props.isOpen ? "100%" : "0")};
  background-color: rgba(0,0,0,0.3);
  transition: left 0.4s cubic-bezier(0, 0, 0, 1);
  z-index:4900;
`;

export const CalculateModal = styled.div`
  position: fixed;
  top: 0;
  height: 100%;
  width: ${props => (props.isCalculate ? "100%" : "0")};
  background-color: rgba(0,0,0,0.3);
  transition: left 0.4s cubic-bezier(0, 0, 0, 1);
  z-index:4900;
`;

export const OpenButton = styled.button`
  font-size:1.6em;
  text-align: right;
  position: absolute;
  top: 45%;
  left: -160px;
  width: 200px;
  height: 50px;
  border-radius: 10px;
  border-style:none;
  background: ${baseSideMenuButtonColor};
  transition: all 0.3s cubic-bezier(0, 0, 0, 1);
  -webkit-box-shadow: 1.5px 1.5px 2px 0px #000000;
          box-shadow: 1.5px 1.5px 2px 0px #000000;
  &:hover {
    transform: scale(1.1);
    cursor: pointer;
    -webkit-box-shadow: ${baseMenuButtonShadowHover};
            box-shadow: ${baseMenuButtonShadowHover};
  }
  :active {
    background: rgb(54,54,54);
    -webkit-box-shadow: ${baseMenuButtonShadowActive};
            box-shadow: ${baseMenuButtonShadowActive};
  }
  :focus {
    outline:0;
  }
  z-index:1000;
  transition: 0.5s all ease-out;
  @media screen and (max-height: 600px) {
    top: 180px;
  }
`;

export const CloseButton = styled.button`
  width: 200px;
  height: 50px;
  color: ${baseMenuFontColor};
  font-size: 1.4em;
  font-family: "Noto Sans TC", sans-serif;
  font-family: arial, "Microsoft JhengHei", "微軟正黑體", sans-serif !important;
  border-radius: 0px;
  border: 2px solid ${baseMenuBorderColor};
  background: ${baseMenuButtonColor};
  margin:5px 5px 5px 5px;
  -webkit-transition: 0.1s cubic-bezier(0, 0, 0, 1);
       -o-transition: 0.1s cubic-bezier(0, 0, 0, 1);
          transition:0.1s cubic-bezier(0, 0, 0, 1);
  :hover {
  transform: scale(1.1);
  cursor: pointer;
  position: relative;
  color: ${baseMenuFontColorHover};
  top: -2px;
  background: ${baseMenuButtonColorHover};
  -webkit-box-shadow: ${baseMenuButtonShadowHover};
          box-shadow: ${baseMenuButtonShadowHover};
  }
  :active {
  position: relative;
  color: ${baseMenuFontColorActive};
  top: 0px;
  background: ${baseMenuButtonColorActive};
  -webkit-box-shadow: ${baseMenuButtonShadowActive};
          box-shadow: ${baseMenuButtonShadowActive};
  }
  :focus {
  outline:0;
  }
`;

export const SideButton = styled.button`
    width: 100%;
    height: 16.6%;
    color: ${baseMenuFontColor};
    font-size: 1.2em;
    font-weight: 900;
    font-family: arial, "Microsoft JhengHei", "微軟正黑體", sans-serif !important;
    border: 2px solid ${baseMenuBorderColor};
    background: ${baseMenuButtonColor};
    -webkit-transition: 0.1s all ease-out;
         -o-transition: 0.1s all ease-out;
            transition: 0.1s all ease-out;
    :hover {
      position: relative;
      top: -2px;
      color: ${baseMenuFontColorHover};
      background: ${baseMenuButtonColorHover};
      -webkit-box-shadow: ${baseMenuButtonShadowHover};
              box-shadow: ${baseMenuButtonShadowHover};
    }
    :active {
        position: relative;
        top: 0px;
        color: ${baseMenuFontColorActive};
        background: ${baseMenuButtonColorActive};
        -webkit-box-shadow: ${baseMenuButtonShadowActive};
                box-shadow: ${baseMenuButtonShadowActive};
        }
    :focus {
    outline:0;
    }
    @media screen and (max-width: 600px) {
      width: 100%;
      height: 16.6%;
    }
    @media screen and (max-height: 600px) {
      font-size: 1em;
      width: 50%;
      height: 33%;
    }
    @media screen and (max-height: 400px) and (max-width: 400px) {
      font-size: 0.6em;
      width: 46%;
      height: 25%;
    }
`;
